<template>
	<v-container grid-list-xl>
		<v-form v-model="isAddValid">     
			<v-layout row wrap>
              <p>This is the increment that will be increased by once the upper limit of the set tiers has been reached.<br />If the top tier is 8 and the price is R800, the next incremental price will be "incremental price" * "quantity".</p>
				<v-flex lg6>
					<label class="blackLabel">* Incremental Price Increase:</label>			
                    <v-text-field label="Incremental price increase" type="number" v-model="globalModalParams.base" required :rules="baseRules" single-line solo></v-text-field>
				</v-flex>				
				<div class="pl-4 pr-1 pb-4 buttonHolder">
					<div style="float: right">
						<v-btn color="success" class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
						<v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isAddValid" @click.stop="fncUpdateBaseTier()">Update</v-btn>
                        <small>* The button will activate once all required fields have been completed</small>
					</div>
				</div>				
			</v-layout>
		</v-form>	
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	
	export default {
	  name: 'Settings',
	  data () {
			return {
				isAddValid: false,
                basePrice: '0',                
				baseRules: [
					v => !!v || 'Base price is required',				
				]                
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
            fncUpdateBaseTier() {				
              this.$store.dispatch('fncUpdateBaseTier', this.globalModalParams.base);                  
			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'runAdd'
			])
        }
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>